import { TooltipContainer } from "@outplayed/tooltips";
import { CURRENT_PATCH } from "api/apiHelpers";
import { MediaQuery } from "@outplayed/responsive";
import { getDeadlockTierColor, getDeadlockTierLetter } from "lib/tierHelper";
import { Abilities } from "./BuildPageContainer";
import { getDeadlockImagePath } from "lib/general-helper";
import AbilityTooltip from "components/AbilityTooltip";

interface HeroBuildHeaderProps {
  heroName: string;
  heroImagePath: string;
  tierNumber: number;
  abilities: Abilities;
}

const HeroBuildHeader = (props: HeroBuildHeaderProps) => {
  const { heroName, heroImagePath, tierNumber, abilities } = props;

  const heroImage = getDeadlockImagePath(heroImagePath);

  return (
    <div className="hero-build-header">
      <div className="hero-build-header-wrapper">
        <div className="hero-image-container" style={{ borderColor: getDeadlockTierColor(tierNumber) }}>
          {tierNumber > 0 && (
            <div className="tier-header" style={{ borderColor: getDeadlockTierColor(tierNumber) }}>
              {getDeadlockTierLetter(tierNumber)}
            </div>
          )}
          <div className="hero-image-border">
            {tierNumber > 0 && <div className="border-notch" />}
            <img
              className="hero-image"
              src={`https://static.bigbrain.gg/deadlock/staticdata/panorama/images${heroImage}.png`}
              alt={heroName}
            />
          </div>
        </div>
        <div className="hero-header-info">
          <h1 className="hero-label">
            <span className="hero-name">{heroName}</span>
            <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
              <span className="hero-title">Build & Items</span>
            </MediaQuery>
            <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
              <span className="hero-title">Build & Items</span>
            </MediaQuery>
            {/* <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
              <div className="header-patch">
                <span>Patch&nbsp;</span>
                {CURRENT_PATCH}
              </div>
            </MediaQuery> */}
          </h1>
          <div className="hero-header-row-2">
            <div className="hero-header-row-2-wrapper">
              <div className="skills-container">
                {Object.keys(abilities).map((key, index) => {
                  const abilityImage = getDeadlockImagePath(abilities[key].abilityImage, abilities[key].name);
                  return (
                    <TooltipContainer
                      key={index}
                      tooltipInfo={
                        <AbilityTooltip
                          ability={{
                            name: abilities[key].name,
                            description: abilities[key].desc,
                            abilityImage: abilities[key].abilityImage,
                            stats: abilities[key].stats,
                            t1Desc: abilities[key].t1Desc,
                            t2Desc: abilities[key].t2Desc,
                            t3Desc: abilities[key].t3Desc,
                            upgrades: abilities[key].upgrades,
                          }}
                        />
                      }
                    >
                      <div className="skill-square">
                        <img
                          src={`https://static.bigbrain.gg/deadlock/staticdata/panorama/images${abilityImage}.png`}
                          alt={abilities[key].name}
                        />
                        <div className="skill-number-bg-circle" />
                        <div className="skill-number">{index + 1}</div>
                      </div>
                    </TooltipContainer>
                  );
                })}
              </div>
              <MediaQuery min="TABLET" max="DESKTOP_LARGE" renderNullOnFail>
                <div className="seo-text">
                  {heroName} build with the highest winrate item buy and sell priority. U.GG analyzes thousands of Deadlock
                  matches to give you the best Deadlock hero build.
                </div>
              </MediaQuery>
            </div>
            {/* <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
              <div className="header-patch">
                <span>Patch&nbsp;</span>
                {CURRENT_PATCH}
              </div>
            </MediaQuery> */}
          </div>
        </div>
      </div>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
        <div className="seo-text">
          {heroName} build with the highest winrate item buy and sell priority. U.GG analyzes thousands of Deadlock matches to
          give you the best Deadlock hero build.
        </div>
      </MediaQuery>
    </div>
  );
};

export default HeroBuildHeader;
